var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_74",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1 10.2C2.28335 10.2 0 7.91665 0 5.1C0 2.28335 2.28335 0 5.1 0C7.91665 0 10.2 2.28335 10.2 5.1C10.2 6.29212 9.79098 7.38871 9.10562 8.25709L11.8243 10.9757C12.0586 11.2101 12.0586 11.59 11.8243 11.8243C11.59 12.0586 11.2101 12.0586 10.9757 11.8243L8.25709 9.10562C7.38871 9.79098 6.29212 10.2 5.1 10.2ZM7.81916 7.89573C7.11665 8.57912 6.15746 9.00001 5.09998 9.00001C2.94606 9.00001 1.19998 7.25392 1.19998 5.10001C1.19998 2.9461 2.94606 1.20001 5.09998 1.20001C7.25389 1.20001 8.99998 2.9461 8.99998 5.10001C8.99998 6.15748 8.5791 7.11665 7.89573 7.81916C7.88199 7.83064 7.86864 7.84283 7.85574 7.85574C7.84283 7.86864 7.83064 7.88199 7.81916 7.89573Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#354052",
    fillOpacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMag);
export default __webpack_public_path__ + "static/media/mag.68a573ce4a6f172e91a33c4e8aa87090.svg";
export { ForwardRef as ReactComponent };